import CaptureExtra from './CaptureExtra';

export default CaptureExtra;
